<script setup lang="ts">
import { UIButton } from '@groover-dev/groover-ui'

import { useProvideCoreFetch } from '~/composables/useProvideCoreFetch'

import { provideFetchPlanCheckout } from '~/api-core/Subscription/Plan'

import type { GrooverPlusSubscribeCtaFragment } from '~/graphql/generated'

type Props = GrooverPlusSubscribeCtaFragment

withDefaults(defineProps<Props>(), {
  text: '',
})

const { coreFetch } = useProvideCoreFetch()
const { selectedPlanId } = storeToRefs(useSubscriptionStore())
const stripeCheckoutModalClientSecret = useState<string | undefined>(
  'stripeCheckoutModalClientSecret',
  () => undefined,
)

async function handleClick() {
  const fetchPlanCheckout = provideFetchPlanCheckout(coreFetch)

  const { client_secret: clientSecret } = await fetchPlanCheckout({
    planId: selectedPlanId.value,
    returnUrl: location.href,
  })

  stripeCheckoutModalClientSecret.value = clientSecret
}
</script>

<template>
  <UIButton
    :text
    variant="primary"
    color="accent"
    size="large"
    @click="handleClick"
  />
</template>
